import { Beacon } from "./Beacon.js";
/**
 * An observable that buffers events over a specified time span
 * and emits them as an array.
 */
export class BufferedObservable extends Beacon {
    /**
     * If provided, maintains a strong reference to a source observable
     * to prevent it from being garbage collected.
     */
    #source$;
    #timeSpan;
    #emitter;
    #subscription;
    #buffer = [];
    #timeoutId = undefined;
    #latestEventAt = undefined;
    constructor(timeSpan, source$) {
        let emitter;
        super((_emitter) => (emitter = _emitter));
        this.#source$ = source$;
        this.#timeSpan = timeSpan;
        this.#emitter = emitter;
        this.#subscription = this.#source$?.subscribe(this);
    }
    next(event) {
        this.#buffer.push(event);
        const timeLeft = this.#latestEventAt !== undefined
            ? this.#timeSpan - (Date.now() - this.#latestEventAt)
            : this.#timeSpan;
        if (this.#timeoutId) {
            clearTimeout(this.#timeoutId);
        }
        this.#timeoutId = setTimeout(() => {
            this.#flush();
            this.#timeoutId = undefined;
            this.#latestEventAt = undefined;
        }, timeLeft);
        this.#latestEventAt = Date.now();
    }
    #flush() {
        if (this.#buffer.length > 0) {
            this.#emitter.next(this.#buffer);
            this.#buffer = [];
        }
    }
    #halt() {
        this.#subscription?.unsubscribe();
        this.#subscription = undefined;
        if (this.#timeoutId) {
            clearTimeout(this.#timeoutId);
            this.#timeoutId = undefined;
        }
        this.#latestEventAt = undefined;
    }
    complete() {
        this.#flush();
        this.#halt();
        this.#emitter.complete();
    }
    error(error) {
        this.#flush();
        this.#halt();
        this.#emitter.error(error);
    }
}
export function bufferObservable(arg1, arg2) {
    if (typeof arg1 === "number") {
        const timeSpan = arg1;
        return (source$) => new BufferedObservable(timeSpan, source$);
    }
    const source$ = arg1;
    const timeSpan = arg2;
    // TODO: Remove in production builds
    if (timeSpan === undefined) {
        throw new Error("timeSpan must be provided when the source observable is provided.");
    }
    return new BufferedObservable(timeSpan, source$);
}
